import React, { lazy, Suspense } from "react";
import { useInView } from "react-intersection-observer";

const OtherPageComponent = lazy(() => import("../../components/home/other_page.component"));

const LazyOther = ({ callToAction }: any) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });


  return (
    <div ref={ref}>
      {inView ? (
        <Suspense fallback={<div>Cargando Portafolio...</div>}>
          <OtherPageComponent callToAction={callToAction} />
        </Suspense>
      ) : (
        <div>Cargando Oportunidades...</div>
      )}
    </div>
  );
};

export default LazyOther;
